import { useSetting } from '@/api/useUserSettings'
import { useUserSettings } from '@hooks/settings'
import { createContext, useContext, useEffect, useState } from 'react'
import { getDirectiveDayStartUTC } from './util'

const DirectiveContext = createContext()

export const DirectiveContextProvider = ({ children }) => {
  const [filters, setFilters] = useState()
  const [serverParams, setServerParams] = useState([])
  const [selectedDate, setSelectedDate] = useState(getDirectiveDayStartUTC())
  const [selectedDirective, setSelectedDirective] = useState()
  const [selectedPrice, setSelectedPrice] = useState()
  const [viewingPlanned, setViewingPlanned] = useSetting('directiveFilters:viewingPlanned', true)
  const [viewingWeekly, setViewingWeekly] = useSetting('directiveFilters:viewingWeekly', true)
  const [lastSaved, setLastSaved] = useState()
  const [rowCount, setRowCount] = useState()
  const { updateSetting, getSetting } = useUserSettings()

  useEffect(() => {
    getSetting('directiveFilters').then((newFilters) => {
      newFilters && setFilters(newFilters)
    })
  }, [])

  useEffect(() => {
    if (filters) {
      updateSetting('directiveFilters', filters).then()
      window.localStorage.setItem('directiveFilters', JSON.stringify(filters))
    }
  }, [filters])

  const clearState = () => {
    setSelectedDirective(undefined)
    setSelectedPrice(undefined)
  }

  const selectDirective = (directive) => {
    setSelectedPrice(undefined)
    setSelectedDirective(directive)
  }

  return (
    <DirectiveContext.Provider
      value={{
        setServerParams,
        serverParams,
        filters,
        setFilters,
        selectedDate,
        setSelectedDate,
        selectDirective,
        selectedPrice,
        setSelectedPrice,
        selectedDirective,
        setSelectedDirective,
        viewingPlanned,
        setViewingPlanned,
        viewingWeekly,
        setViewingWeekly,
        clearState,
        lastSaved,
        setLastSaved,
        rowCount,
        setRowCount,
      }}
    >
      {children}
    </DirectiveContext.Provider>
  )
}

export const useDirectiveContext = () => {
  const context = useContext(DirectiveContext)
  if (context === undefined) {
    throw new Error('Context must be used within a Provider')
  }
  return context
}
